import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild} from '@angular/core';
import {ItemActionElement} from "./item-action-element";
import {ItemActionsService} from "./item-actions.service";
import {ItemActionsDirective} from "../../directives/item-actions.directive";
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-item-actions',
  templateUrl: './item-actions.component.html',
  styleUrls: ['./item-actions.component.scss']
})
export class ItemActionsComponent implements AfterViewInit, OnDestroy, Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @ViewChild('menuEl') menuEl!: ElementRef;
  @Input('menu-items') set setMenuItems(val: ItemActionElement[]) {
    this.menuItems = val;
  }
  @Input('title') title: string = "";
  @Input('associatedDirective') associatedDirective!: ItemActionsDirective;

  menuItems: ItemActionElement[] = [];
  isVisible = false;
  menuPositionX: "left" | "center" | "right" = "center";
  menuPositionY: "top" | "bottom" = "bottom";



  constructor(private itemActions: ItemActionsService) {
  }

  ngAfterViewInit() {
    this.setMenuPosition();
  }

  setMenuPosition() {
    this.setDefaultMenuPosition();
    window.requestAnimationFrame(() => {
      if(this.menuEl) {
        const menuElHTML = this.menuEl.nativeElement as HTMLElement;
        const crect = menuElHTML.getBoundingClientRect();
        const hasOverflowRight = crect.right >= window.innerWidth;
        const hasOverflowLeft = crect.left <= 0;
        const hasOverflowBottom = crect.bottom >= window.innerHeight;
        const hasOverflowTop = crect.top <= 0;
        if(hasOverflowRight) {
          this.menuPositionX = "right";
        } else if(hasOverflowLeft) {
          this.menuPositionX = "left"
        } else {
          this.menuPositionX = "center";
        }

        if(hasOverflowBottom) {
          this.menuPositionY = "top";
        } else {
          this.menuPositionY = "bottom";
        }

        this.isVisible = true;
      }
    })
  }

  setDefaultMenuPosition() {
    this.menuPositionX = "center";
    this.menuPositionY = "bottom";
  }

  onItemClicked($event: MouseEvent) {
    $event.stopPropagation();
    $event.preventDefault();
    if(window.innerWidth < 992) {
      this.onClosed.emit(true); // close for mobile
    } else {
      this.itemActions.deactivate(this.associatedDirective); // close for desktop

      (this.associatedDirective.el.element.nativeElement as HTMLElement).focus();

    }
  }

  ngOnDestroy() {
    this.itemActions.deactivate(this.associatedDirective);
  }

  // onFocus($event: FocusEvent) {
  //   console.log(this.associatedDirective.el.element.nativeElement)
  //   console.log($event);
  //
  //   if($event.relatedTarget) {
  //     const directiveElement = this.associatedDirective.el.element.nativeElement as Element;
  //     if(!directiveElement.contains($event.relatedTarget as Node)) {
  //       this.itemActions.deactivate(this.associatedDirective);
  //     }
  //   }
  //
  // }
}


